import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { EResponseBase } from '../data/base/ResponseBase';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  upload(formData: FormData){
    return this.http.post<EResponseBase<any>>(`${environment.url}/Document/Upload`, formData);
  }

}
